import CustomTemplateButton from '../../../components/CustomTemplateButton';
import FunctionalityTemplateDragBtn from './../Functionality/TemplateDragButtons';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const TemplateDragButtons = ({ handleDragStart, setShowResources }) => {
    const { buttonsData, handleGetResources } = FunctionalityTemplateDragBtn({handleDragStart, setShowResources});
    return (
        <div className='mr-3'>
            <div className='d-flex flex-column'>
                {buttonsData.map((button, index) => (
                    <CustomTemplateButton
                        key={index}
                        iconSrc={button.iconSrc}
                        transferType={button.transferType}
                        onDragStart={button.onDragStart}
                        onClick={button.onClick}
                        altText={button.altText}
                        className={button.className}
                    />
                ))}
            </div>
        </div>
    );
};

export default TemplateDragButtons;
